module.exports = __webpack_public_path__ + "static/media/29_A.075daa31.png";